<template>
  <div class="event">
    <!-- 岗位记录 -->

    <div
      class="eventTitle"
      v-if="
        event === undefined
          ? list[key1][index]['时间'].dataSourceType === 'CONSUMER'
          : key1 !== '社会活动经历'
      "
    >
      <el-checkbox
        slot="checkAllEvent"
        v-if="isSelect && checkList[key1].value[index][key2]"
        v-model="checkList[key1].value[index][key2].checkAll"
        :indeterminate="checkList[key1].value[index][key2].indeterminate"
        @change="handleCheckAll($event, key1, key2, index)"
      ></el-checkbox
      >{{ key2 }}
    </div>
    <div class="eventList">
      <div
        v-if="isSelect ? !eItem['时间'].deleteTag : true"
        class="eventItem"
        v-for="(eItem, eIndex) in event"
        :key="eItem['上级Id']"
      >
        <div class="displayBox">
          <el-checkbox
            v-if="isSelect"
            v-model="
              checkList[key1].value[index][key2].value[eIndex][
                Object.keys(eItem)
                  .filter(e => e !== '上级Id')
                  .map(r => eItem[r].dataId.toString())
              ]
            "
            @change="handleCheckedChange($event, key1, key2, index)"
          >
          </el-checkbox>
          <div class="eventCheckItem">
            <!-- 时间 -->
            <div class="eventDateItem">
              <div style="display: flex;align-items: center;">
                <div
                  :class="
                    `eventDate ${eItem['时间'].deleteTag && 'deleteLine'}`
                  "
                >
                  {{
                    eItem["时间"].dataValue.split(",").length > 1
                      ? eItem["时间"].dataValue.split(",")[0] +
                        "-" +
                        eItem["时间"].dataValue.split(",")[1]
                      : eItem["时间"].dataValue
                  }}
                </div>
                <span
                  v-if="eItem['时间'].deleteTag"
                  style="color:#FF4C4C;margin-left:15px"
                  >已删除</span
                >
              </div>
              <div class="eventUpdateDate">
                <div v-if="key1 !== '社会活动经历'">
                  数据更新于{{
                    eItem["时间"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                </div>
                <div v-else>
                  {{
                    eItem["时间"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                  {{
                    `由 ${eItem["时间"].dataSourceName}${
                      eItem["时间"].deleteTag
                        ? "删除"
                        : eItem["时间"].dataSourceType === "CONSUMER"
                        ? "自填"
                        : "添加"
                    }`
                  }}
                </div>
                <OperationList
                  v-if="!isSelect"
                  :data="eItem['时间']"
                  :isEdit="true"
                  :isDelete="true"
                  @handleEdit="handleEditEvent(eItem, eItem['上级Id'], index)"
                  @handleDelete="
                    handleDeleteAll(eItem['上级Id'], '事件/活动记录')
                  "
                />
                <!-- <div class="eventOperation">
                  <span>勘误</span>
                  <span>数据记录</span>
                </div> -->
              </div>
            </div>

            <div class="eventContentItem" v-if="eItem['岗位名称']">
              <div style="display: flex;align-items: center;">
                <div
                  :class="
                    `eventContent ${eItem['岗位名称'].deleteTag &&
                      'deleteLine'}`
                  "
                >
                  {{ eItem["岗位名称"].dataValue }}
                </div>
                <span
                  v-if="eItem['岗位名称'].deleteTag"
                  style="color:#FF4C4C;margin-left:15px"
                  >已删除</span
                >
              </div>
              <div class="eventUpdateDate">
                <div v-if="key1 !== '社会活动经历'">
                  数据更新于{{
                    eItem["岗位名称"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                </div>
                <div v-else>
                  {{
                    eItem["时间"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                  {{
                    `由 ${eItem["时间"].dataSourceName}${
                      eItem["时间"].deleteTag
                        ? "删除"
                        : eItem["时间"].dataSourceType === "CONSUMER"
                        ? "自填"
                        : "添加"
                    }`
                  }}
                </div>

                <OperationList v-if="!isSelect" :data="eItem['岗位名称']" />
              </div>
            </div>
            <!-- 内容 -->
            <div class="eventContentItem">
              <div style="display: flex;align-items: center;">
                <div
                  :class="
                    `eventContent ${eItem['内容'].deleteTag && 'deleteLine'}`
                  "
                >
                  {{ eItem["内容"].dataValue }}
                </div>
                <span
                  v-if="eItem['内容'].deleteTag"
                  style="color:#FF4C4C;margin-left:15px"
                  >已删除</span
                >
              </div>
              <div class="eventUpdateDate">
                <div v-if="key1 !== '社会活动经历'">
                  数据更新于{{
                    eItem["内容"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                </div>
                <div v-else>
                  {{
                    eItem["内容"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                  {{
                    `由 ${eItem["内容"].dataSourceName}${
                      eItem["内容"].deleteTag
                        ? "删除"
                        : eItem["内容"].dataSourceType === "CONSUMER"
                        ? "自填"
                        : "添加"
                    }`
                  }}
                </div>
                <!-- <div class="eventOperation">
                  <span>勘误</span>
                  <span>数据记录</span>
                </div> -->
                <OperationList v-if="!isSelect" :data="eItem['内容']" />
              </div>
            </div>
            <!-- 附件 -->
            <div class="eventFile" v-if="eItem['附件']">
              <div class="eventFileTop">
                <div class="eventFileTitle">附件：</div>
                <div class="eventFileList">
                  <div
                    @click="handlePreviewImg(file)"
                    class="eventFileItem"
                    v-for="(file, fileIndex) in eItem['附件'].dataValue.split(
                      ','
                    )"
                    :key="fileIndex"
                  >
                    {{ file.split(":")[2] }}
                  </div>
                </div>
              </div>
              <div class="eventUpdateDate" v-if="key1 !== '社会活动经历'">
                数据更新于{{
                  eItem["附件"].lastUpdateDate
                    | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                }}
              </div>
              <div style="display: flex;justify-content: space-between;">
                <div class="eventUpdateDate">
                  {{
                    eItem["附件"].lastUpdateDate
                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                  }}
                  {{
                    `由 ${eItem["附件"].dataSourceName}${
                      eItem["附件"].deleteTag
                        ? "删除"
                        : eItem["附件"].dataSourceType === "CONSUMER"
                        ? "自填"
                        : "添加"
                    }`
                  }}
                </div>
                <OperationList v-if="!isSelect" :data="eItem['附件']" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="eventPost"></div> -->
      </div>
      <div
        :id="scrollRefMap[key1]"
        class="eventItem form"
        v-if="eventForm && eventIndex === index"
      >
        <div class="eventRadioGroup">
          <el-radio
            v-model="eventForm.eventRadio"
            :label="2"
            @change="handleEventRadioChange"
            >时间段</el-radio
          >
          <el-radio
            v-model="eventForm.eventRadio"
            :label="1"
            @change="handleEventRadioChange"
            >时间点</el-radio
          >
        </div>
        <el-form :model="eventForm" label-position="left" label-width="85px">
          <el-form-item label="时间：" v-if="eventForm.eventRadio === 2">
            <div style="display:flex;">
              <el-date-picker
                :editable="false"
                v-model="eventForm['时间'].startDate"
                value-format="yyyy-MM-dd"
                style="width: 272.5px;"
              ></el-date-picker>
              <span style="margin-left:10px;margin-right:10px">-</span>
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="eventForm['时间'].endDate"
                style="width: 272.5px;"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item v-else label="时间：">
            <div style="display:flex">
              <el-date-picker
                :editable="false"
                v-model="eventForm['时间'].startDate"
                value-format="yyyy-MM-dd"
                style="width: 272.5px;"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="岗位名称：" v-if="eventForm['岗位名称']">
            <el-input
              type="input"
              v-model="eventForm['岗位名称'].dataValue"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="`${key2 === '岗位记录' ? '岗位' : '事件'}描述：`"
          >
            <el-input
              type="textarea"
              v-model="eventForm['内容'].dataValue"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件：">
            <div class="fileList">
              <div
                class="fileItem"
                v-for="(fItem, fIndex) in fileList"
                :key="fItem.uid"
              >
                {{ fItem.name
                }}<i
                  @click="handleRemoveFile(fIndex)"
                  class="icon_fileRemove"
                ></i>
              </div>
            </div>
            <el-upload
              ref="upload"
              class="upload"
              action=""
              :auto-upload="false"
              multiple
              :show-file-list="false"
              :on-change="
                event => handleEventUploadChange(event, index, eventIndex)
              "
            >
              <span style="color:#3A61B1;text-decoration: underline;"
                >+选择附件</span
              >
              <div slot="tip" class="el-upload__tip">
                选择图片附件上传。
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <Btn
              btnText="提交"
              :width="69"
              :height="30"
              :radius="15"
              @handleClick="handleSubmitEduEventForm"
            />
            <Btn
              btnText="取消"
              className="primary_plain"
              :width="69"
              :height="30"
              :radius="15"
              style="margin-left:13px"
              @handleClick="handleCloseEventForm"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <template v-if="key1 === '社会活动经历'">
      <div
        class="btn_eventAdd"
        v-if="eventForm === undefined && !isSelect"
        @click="handleAddEduEvent(index)"
      >
        +{{ key1 }}
      </div>
    </template>
    <template v-else>
      <div
        class="btn_eventAdd"
        v-if="
          list[key1][index]['时间'].modifiable &&
            eventForm === undefined &&
            !isSelect
        "
        @click="handleAddEduEvent(index)"
      >
        +{{ key2 }}
      </div>
    </template>
    <div class="confirmDeleteAll" v-if="confirmDeleteAll">
      <CoverLayout>
        <div slot="content" class="confirmBox">
          <div class="title">
            {{ `确定删除该${deletePayload.formName}吗？` }}
          </div>
          <div class="text">
            {{
              `一经确认删除，该${deletePayload.formName}相关所有信息将会被一同删除！`
            }}
          </div>
          <div class="btns">
            <Btn
              btnText="取消"
              className="default"
              :width="100"
              :height="41"
              @handleClick="confirmDeleteAll = false"
            />
            <Btn
              btnText="确定"
              className="primary"
              :width="100"
              :height="41"
              @handleClick="handleConfirmDeleteAll"
            />
          </div>
        </div>
      </CoverLayout>
    </div>
  </div>
</template>

<script>
import OperationList from "@/components/OperationList.vue";
import Btn from "@/components/Btn.vue";
import { upload } from "@/api/uploadFile";
import CoverLayout from "@/components/CoverLayout.vue";
import {
  // getUserInfoByKey,
  updatePersonalInfo,
  updateWithDataId,
  deleteInfo
  // reportSave
} from "@/api/user";
export default {
  props: {
    event: {
      type: Array
      // value:{}
    },
    isSelect: {
      type: Boolean
    },
    checkList: {
      type: Object
    },
    key1: {
      type: String
    },
    key2: {
      type: String
    },
    index: {
      type: Number
    },
    list: {
      type: Object
    }
  },
  components: { OperationList, Btn, CoverLayout },
  data() {
    return {
      eventForm: undefined,
      eventIndex: 0,
      fileList: [],
      confirmDeleteAll: false,
      deletePayload: {
        formName: "",
        params: ""
      },
      scrollRefMap: {
        学历教育: "eduForm",
        非学历教育: "noEduForm",
        职业经历: "proExpForm",
        社会活动经历: "socialForm"
      }
    };
  },
  created() {
    console.log("event", this.event);
  },
  methods: {
    handleEventRadioChange(val) {
      this.eventForm.eventRadio = val;
    },
    handleCheckAll(flag, key1, key2, index) {
      // console.log(flag, key1, key2, index);
      this.$emit("handleCheckAll", { flag, key1, key2, index });
    },
    handleCheckedChange(flag, key1, key2, index) {
      this.$emit("handleCheckedChange", { flag, key1, key2, index });
    },
    handleAddEduEvent(index) {
      this.eventIndex = index;
      this.fileList = [];
      if (this.key2 === "岗位记录") {
        this.eventForm = {
          type: "add",
          eventRadio: 2,
          时间: {
            startDate: undefined,
            endDate: undefined
          },
          岗位名称: {
            dataValue: ""
          },
          内容: {
            dataValue: ""
          },
          附件: ""
        };
      } else {
        this.eventForm = {
          type: "add",
          eventRadio: 2,
          时间: {
            startDate: undefined,
            endDate: undefined
          },
          内容: {
            dataValue: ""
          },
          附件: ""
        };
      }
    },
    handleEditEvent(row, upId, index) {
      this.eventIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      // console.log('tempData',tempData['时间'].dataValue.split(',').length-1);
      this.fileList = [];
      if (this.key2 === "岗位记录") {
        this.eventForm = {
          岗位名称: { dataId: undefined, dataValue: "" },
          内容: { dataId: undefined, dataValue: "" },
          时间: { dataId: undefined, dataValue: "" },
          附件: { dataId: undefined, dataValue: "" },
          eventRadio: tempData["时间"].dataValue.split(",").length,
          upId,
          type: "edit"
        };
      } else {
        this.eventForm = {
          内容: { dataId: undefined, dataValue: "" },
          时间: { dataId: undefined, dataValue: "" },
          附件: { dataId: undefined, dataValue: "" },
          eventRadio: tempData["时间"].dataValue.split(",").length,
          upId,
          type: "edit"
        };
      }

      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }
      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.eventForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            endDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[1]
              : undefined
          };
        } else {
          this.eventForm[key] = tempData[key];
        }
      });
      // this.formScoll("eduEventForm");
    },
    handleSubmitEduEventForm() {
      if (!this.validateEvent(this.eventForm)) return false;
      if (this.eventForm.type === "edit") {
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.eventForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.eventForm[key] &&
                this.eventForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.eventForm[key].dataId,
                    dataName: this.eventForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.eventForm[key].dataId,
                    dataName: this.eventForm[key].dataName,
                    dataValue:
                      this.eventForm.eventRadio === 0
                        ? this.eventForm[key].startDate +
                          "," +
                          this.eventForm[key].endDate
                        : this.eventForm[key].startDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.eventForm[key].dataId,
                    dataName: this.eventForm[key].dataName,
                    dataValue: this.eventForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.eventForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.eventForm.upId][0][key] = this.fileList
                    .map(item => item.url)
                    .toString();
                } else if (key === "时间") {
                  payloadAdd[this.eventForm.upId][0][key] =
                    this.eventForm.eventRadio === 0
                      ? this.eventForm[key].startDate +
                        "," +
                        this.eventForm[key].endDate
                      : this.eventForm[key].startDate;
                } else {
                  payloadAdd[this.eventForm.upId][0][key] = this.eventForm[
                    key
                  ].dataValue;
                }
                updatePersonalInfo(payloadAdd);
              }
            }
          }
        });
        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.eventForm = undefined;
            this.$emit("handleGetList");
            // this.getList();
          }
        });
      } else {
        let payload = {};
        if (this.key2 === "岗位记录") {
          payload = {
            [this.list[this.key1][this.index]["上级Id"]]: [
              {
                岗位记录: [
                  {
                    岗位名称: this.eventForm["岗位名称"].dataValue,
                    内容: this.eventForm["内容"].dataValue,
                    时间: `${this.eventForm["时间"].startDate},${this.eventForm["时间"].endDate}`,
                    附件: this.fileList.map(item => item.url).toString()
                  }
                ]
              }
            ]
          };
        } else {
          payload = {
            [this.list[this.key1][this.index]["上级Id"]]: [
              {
                "事件/活动记录": [
                  {
                    内容: this.eventForm["内容"].dataValue,
                    时间: `${this.eventForm["时间"].startDate},${this.eventForm["时间"].endDate}`,
                    附件: this.fileList.map(item => item.url).toString()
                  }
                ]
              }
            ]
          };
        }

        // if (
        //   payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === "" ||
        //   payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === undefined
        // ) {
        //   delete payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"];
        // }
        // let time = [];
        // payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"]
        //   .split(",")
        //   .map((item, index) => {
        //     if (item !== "undefined" && item !== "") {
        //       time.push(item);
        //     }
        //   });
        // payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"] = time.toString();

        // if (
        //   payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["附件"] === ""
        // ) {
        //   delete payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["附件"];
        // }
        updatePersonalInfo(payload).then(res => {
          if (res.data.c === 200) {
            this.eventForm = undefined;
            this.$message.success("添加成功");
            // this.getList();
            this.$emit("handleGetList");
          }
        });
      }
    },
    handleCloseEventForm() {
      this.eventForm = undefined;
    },
    async handleEventUploadChange(file, index) {
      let fd = new FormData();
      let fileObj = {
        name: file.name,
        url: ""
      };
      fd.append("file", file.raw);
      fd.append("uploadType", "PC");
      await upload(fd).then(res => {
        fileObj.url = res.data.d;
        this.fileList.push(fileObj);
      });
    },
    validateEvent(form, isPost) {
      let flag = true;
      if (this.eventForm.eventRadio === 0) {
        if (!this.eventForm["时间"].startDate) {
          this.$message.error("开始时间不能为空");
          flag = false;
          return;
        }
        if (!this.eventForm["时间"].endDate) {
          this.$message.error("结束时间不能为空");
          flag = false;
          return;
        }
        if (
          new Date(this.eventForm["时间"].startDate).getTime() >
          new Date(this.eventForm["时间"].endDate).getTime()
        ) {
          this.$message.error("时间范围不正确");
          flag = false;
          return;
        }
      } else {
        if (!this.eventForm["时间"].startDate) {
          this.$message.error("开始时间不能为空");
          flag = false;
          return;
        }
      }
      if (isPost) {
        if (!this.eventForm["岗位名称"].dataValue) {
          this.$message.error("岗位名称不能为空");
          flag = false;
          return;
        }
      }
      if (!this.eventForm["内容"].dataValue) {
        this.$message.error("事件描述不能为空");
        flag = false;
        return;
      }
      return flag;
    },
    handleDeleteAll(dataId, formName) {
      this.confirmDeleteAll = true;
      this.deletePayload = {
        formName,
        params: dataId
      };
    },
    handleConfirmDeleteAll() {
      deleteInfo({ dataId: this.deletePayload.params, deleteAll: true }).then(
        res => {
          if (res.data.c === 200) {
            this.$message.success("删除成功");
            this.confirmDeleteAll = false;
            // this.getList();
            this.$emit("handleGetList");
          }
        }
      );
    },
    handlePreviewImg(url) {
      this.$emit("handlePreviewImg", url);
    }
  }
};
</script>

<style lang="scss" scoped>
.event {
  margin-bottom: 50px;
  .eventOperation {
    span {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3a61b1;
      line-height: 50px;
      margin-left: 13px;
    }
  }
  .eventUpdateDate {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #878787;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
  }
  .btn_eventAdd {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    text-decoration: underline;
    color: #3a61b1;
    display: inline-block;
    line-height: 50px;
    cursor: pointer;
    // padding-left: 37px;
  }
  .eventTitle {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #393939;
    line-height: 30px;
  }
  .eventList {
    padding-left: 37px;
    margin-top: 17px;
    .eventItem {
      position: relative;
      padding-bottom: 20px;
      &::after {
        content: "";
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #3a61b1;
        position: absolute;
        left: -14px;
        top: 10px;
      }
      &::before {
        content: "";
        border-left: 1px solid rgba(58, 97, 177, 0.33);
        position: absolute;
        // height: calc(100% - 17px);
        // left: -11px;
        // bottom: 0;
        height: 100%;
        left: -11px;
        bottom: -10px;
      }
      .displayBox {
        display: flex;
        align-items: baseline;
        .eventCheckItem {
          flex: 1;
          .eventDateItem {
            display: flex;
            flex-direction: column;
            .eventDate {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #393939;
              line-height: 26px;
            }
          }
          .eventContentItem {
            .eventContent {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 600;
              color: #393939;
              line-height: 26px;
            }
          }

          .eventFile {
            background: #d1dbee;
            padding: 20px;
            margin-top: 5px;
            display: flex;
            flex-direction: column;
            .eventFileTop {
              display: flex;
              align-items: baseline;
              cursor: pointer;
              .eventFileTitle {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #393939;
                line-height: 26px;
              }
              .eventFileList {
                .eventFileItem {
                  // display: flex;
                  // justify-content: space-between;
                  font-weight: bold;
                  color: #3a5891;
                  .eventFileName {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 600;
                    color: #3a5891;
                    line-height: 30px;
                  }
                }
              }
            }
          }
        }
      }
      .deleteLine {
        text-decoration: line-through;
      }
    }
    .form {
      .eventRadioGroup {
        padding: 1px 0 15px 0;
      }
    }
  }
}
.confirmBox {
  background: #fff;
  width: 430px;
  height: 226px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 16px;
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #393939;
    line-height: 41px;
  }
  .text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8d8d8d;
    line-height: 24px;
  }
  .btns {
    margin-top: 31px;
    button {
      &:last-child {
        margin-left: 35px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EventList.vue